import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConsumerServicesComponent} from './consumer-services.component';
import {AddressFormComponent} from '../common/forms/address-form/address-form.component';
import {HawkFormComponent} from './subject-form/hawk-form/hawk-form.component';
import {HawkTypeComponent} from './subject-form/hawk-form/hawk-type/hawk-type.component';
import {HawkSinDobComponent} from './subject-form/hawk-form/hawk-sin-dob/hawk-sin-dob.component';
import {StandardSubjectFormComponent} from './subject-form/standard-subject-form/standard-subject-form.component';
import {ConsumerCreditReportComponent} from './reports/consumer-credit-report/consumer-credit-report.component';
import {IfsReportComponent} from './reports/ifs-report/ifs-report.component';
import {MdsReportComponent} from './reports/mds-report/mds-report.component';
import {DirsLookupFormComponent} from './subject-form/dirs-lookup-form/dirs-lookup-form.component';
import {ConsumerSubjectFormComponent} from './subject-form/standard-subject-form/consumer-subject-form/consumer-subject-form.component';
import {AvsSubjectFormComponent} from './subject-form/standard-subject-form/avs-subject-form/avs-subject-form.component';
import {BvsSubjectFormComponent} from './subject-form/standard-subject-form/bvs-subject-form/bvs-subject-form.component';
import {AmlSubjectFormComponent} from './subject-form/standard-subject-form/aml-subject-form/aml-subject-form.component';
import {DirsSubjectFormComponent} from './subject-form/standard-subject-form/dirs-subject-form/dirs-subject-form.component';
import {EamlReportComponent} from './reports/eaml-report/eaml-report.component';
import {ConsumerCreditReportContentComponent} from './reports/consumer-credit-report/consumer-credit-report-content/consumer-credit-report-content.component';
import {IfsReportContentComponent} from './reports/ifs-report/ifs-report-content/ifs-report-content.component';
import {ConsumerCreditReportSidenavComponent} from './reports/consumer-credit-report/consumer-sidenav/consumer-credit-report-sidenav.component';
import {EamlSubjectFormComponent} from './subject-form/standard-subject-form/eaml-subject-form/eaml-subject-form.component';
import {EdirsSubjectFormComponent} from './subject-form/standard-subject-form/edirs-subject-form/edirs-subject-form.component';
import {CommonTudComponentsModule} from '../common/common-tud-components.module';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatStepperModule} from '@angular/material/stepper';
import {ConsumerServicesRoutingModule} from './consumer-services-routing.module';
import {NgxMaskModule} from 'ngx-mask';

@NgModule({
    imports: [
        //TUD Modules
        ConsumerServicesRoutingModule,
        CommonTudComponentsModule,
        //Dependencies
        CommonModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        NgxMaskModule.forChild(),
        MatStepperModule,
        ConsumerServicesComponent,
        AddressFormComponent,
        HawkFormComponent,
        HawkTypeComponent,
        HawkSinDobComponent,
        StandardSubjectFormComponent,
        ConsumerCreditReportComponent,
        IfsReportComponent,
        MdsReportComponent,
        DirsLookupFormComponent,
        ConsumerSubjectFormComponent,
        AvsSubjectFormComponent,
        BvsSubjectFormComponent,
        AmlSubjectFormComponent,
        DirsSubjectFormComponent,
        EamlReportComponent,
        ConsumerCreditReportContentComponent,
        IfsReportContentComponent,
        ConsumerCreditReportSidenavComponent,
        EamlSubjectFormComponent,
        EdirsSubjectFormComponent
    ]
})
export class ConsumerServicesModule {}
